/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCornerRightUp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M16 21H2v-2h12V6.4l-3.3 3.3-1.4-1.4L15 2.6l5.7 5.7-1.4 1.4L16 6.4z"
    />
  </Icon>
);
export { SvgCornerRightUp as CornerRightUp };
